export const SubscriptionStatus = {
  draft: 'draft',
  active: 'active',
  paused: 'paused',
  cancelled: 'cancelled',
  void: 'void', // Do not use this, just added this as part of migration requirement
} as const
export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus]

export enum FeedingPlanStatus {
  active = 'active',
  paused = 'paused',
  ineligible = 'ineligible',
  void = 'void', // Do not use this, just added this as part of migration requirement
}

// All voided serving sizes will have prefix as v
// All serving sizes with 1 pouch will have prefix as f (first)
// All serving sizes with 2 pouches will have prefix as d (double)
// All serving sizes with 3 pouches will have prefix as t (triple)
// All serving sizes with 4 pouches will have prefix as q (four)
export const FeedingPlanServingSize = {
  v0100: 'v0100',
  f0125: 'f0125', // 1x
  f0150: 'f0150', // 1x
  v0175: 'v0175',
  f0200: 'f0200', // 1x
  v0225: 'v0225',
  f0250: 'f0250', // 1x
  v0275: 'v0275',
  f0300: 'f0300', // 1x
  v0325: 'v0325',
  v0350: 'v0350',
  v0375: 'v0375',
  f0400: 'f0400', // 1x
  v0425: 'v0425',
  v0450: 'v0450',
  v0475: 'v0475',
  f0500: 'f0500', // 1x
  v0525: 'v0525',
  v0550: 'v0550',
  v0575: 'v0575',
  f0600: 'f0600', // 1x
  v0625: 'v0625',
  v0650: 'v0650',
  v0675: 'v0675',
  f0700: 'f0700', // 1x
  v0725: 'v0725',
  v0750: 'v0750',
  v0775: 'v0775',
  d0800: 'd0800', // 2x400
  v0825: 'v0825',
  v0850: 'v0850',
  v0875: 'v0875',
  v0900: 'v0900',
  v0925: 'v0925',
  v0950: 'v0950',
  v0975: 'v0975',
  d1000: 'd1000', // 2x500
  v1025: 'v1025',
  v1050: 'v1050',
  v1075: 'v1075',
  v1100: 'v1100',
  v1125: 'v1125',
  v1150: 'v1150',
  v1175: 'v1175',
  d1200: 'd1200', // 2x600
  v1225: 'v1225',
  v1250: 'v1250',
  v1275: 'v1275',
  v1300: 'v1300',
  v1325: 'v1325',
  v1350: 'v1350',
  v1375: 'v1375',
  d1400: 'd1400', // 2x700
  v1425: 'v1425',
  v1450: 'v1450',
  v1475: 'v1475',
  v1500: 'v1500',
  v1525: 'v1525',
  v1550: 'v1550',
  v1575: 'v1575',
  q1600: 'q1600', // 4x400
  v1625: 'v1625',
  v1650: 'v1650',
  v1675: 'v1675',
  v1700: 'v1700',
  v1725: 'v1725',
  v1750: 'v1750',
  v1775: 'v1775',
  t1800: 't1800', // 3x600
} as const;
export type FeedingPlanServingSize = typeof FeedingPlanServingSize[keyof typeof FeedingPlanServingSize]

export const Meal = {
  Beef: 'beef',
  Chicken: 'chicken',
  Turkey: 'turkey',
  Lamb: 'lamb',
  Kangaroo: 'kangaroo',
  Goat: 'goat',
  Fish: 'fish',
} as const
export type Meal = typeof Meal[keyof typeof Meal]

/* This determines what kind of feeding plan is used.
    - FEEDING_PLAN: Individual feeding plan and SKU assigned per animal
    - SHARED_FEEDING_PLAN: A shared feeding plan and shared SKUs across animals
*/
export const PlanStrategy = {
  FEEDING_PLAN: 'FEEDING_PLAN',
  SHARED_FEEDING_PLAN: 'SHARED_FEEDING_PLAN',
} as const
export type PlanStrategy = typeof PlanStrategy[keyof typeof PlanStrategy]

export const PriceStrategy = {
  VOLUMETRIC_LYKA_V1: 'VOLUMETRIC_LYKA_V1',
  SKU_TYGA_V1: 'SKU_TYGA_V1',
} as const
export type PriceStrategy = typeof PriceStrategy[keyof typeof PriceStrategy]
